import { Drawer, IconButton, List } from "@material-ui/core";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import styles from "./styles";
import { useSelector } from "react-redux";
import IconMenu from "./IconMenu";
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';

const MenuNavegacion = (props) => {
  const { open, handleDrawerClose } = props;
  const classesMenu = styles();
  const { permisos, profile } = useSelector(store => store.logeo)
  return (
    <Drawer
      className={classesMenu.drawer}
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classesMenu.drawerPaper,
      }}>
      <div className={classesMenu.drawerHeader}>
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Paper variant="outlined" square>
        <div className={classesMenu.drawerHeaderProfile}>
          <Avatar className={classesMenu.orange}>{profile?.Informacion?.Nombre[0]}</Avatar>
          <p style={{ margin: "1px" }}>{`${profile?.Informacion?.Nombre} ${profile?.Informacion?.ApellidoPaterno}  ${profile?.Informacion?.ApellidoMaterno}`}</p>
          <p style={{ margin: "1px" }}>{profile.Email}</p>
          <p style={{ margin: "1px" }}>{`${profile?.Rol?.Name}`}</p>
        </div>
      </Paper>
      <List>
        {permisos.map((item, index) => {
          if (!item.Icono)
            return null
          return (<Link key={index} to={{ pathname: item.Ruta, state: { clavePagina: item.Clave_Permiso } }} style={{ textDecoration: "none" }}>
            <ListItem button >
              <ListItemIcon>
                <IconMenu icon={item.Icono} />
              </ListItemIcon>
              <ListItemText primary={item.Texto} className={classesMenu.links} />
            </ListItem>
          </Link>)
        })}
      </List>
    </Drawer>
  );
}
export default MenuNavegacion;